import { AxiosError } from 'axios';
import { Nullable } from '@dxb-web-ui-framework/common/types';
import { APIGatewayResponse } from '@dxb-web-ui-framework/common/domain/RestfulDataTransfer/DataService/types';
import { NavigateFunction } from 'react-router';
import { Card } from '../../domain/Card/entities/Card';
import { FreezeCardResponseBody } from '../../domain/Card/entities/Card/FreezeCardResponseDTO';

export interface CardActionProviderProps {}

export interface CardActionState {
  freezeCardData?: FreezeCardResponseBody;
  errorState: {
    freezeCardDataError?: AxiosError<APIGatewayResponse<any>, any>;
  };
  onViewCardDetails: (card: Nullable<Card>, navigate?: NavigateFunction) => void;
  onTopUpCard: (card: Nullable<Card>, navigate?: NavigateFunction) => void;
  onFreezeCard: (card: Nullable<Card>) => void;
  onUnfreezeCard: (card: Nullable<Card>) => void;
  onChangePIN: (card: Nullable<Card>) => void;
  onRenewCard: (card: Nullable<Card>, navigate: NavigateFunction) => void;
  onReportCardAsDestroyed: (card: Nullable<Card>) => void;
  onReportCardAsStolen: (card: Nullable<Card>) => void;
  onResetPINRetry: (card: Nullable<Card>) => void;
  onLimits: (card: Nullable<Card>, navigate: NavigateFunction) => void;
  onTerminateCard: (card: Nullable<Card>, navigate?: NavigateFunction) => void;
  onActivateCard: (card: Nullable<Card>, navigate?: NavigateFunction) => void;
  onPermanentBlockCard: (card: Nullable<Card>, navigate: NavigateFunction) => void;
  onResetPinTriesExceeded: (card: Nullable<Card>, navigate: NavigateFunction) => void;
}

export enum CardActionContextActionTypes {
  SetSelectedCardAction = '@@/Cards/SET_SELECTED_CARD_ACTION',
}

export enum CardAction {
  viewDetails = 'VIEW_DETAILS',
  topUpCard = 'TOP_UP',
  freezeCard = 'FREEZE',
  unfreezeCard = 'UNFREEZE',
  changePIN = 'CHANGE_PIN',
  renewCard = 'RENEW_CARD',
  reportCardAsDestroyed = 'REPORT_CARD_AS_DESTROYED',
  reportCardAsStolen = 'REPORT_CARD_AS_STOLEN',
  resetPINRetry = 'RESET_PIN_RETRY',
  limits = 'LIMITS',
  terminateCard = 'TERMINATE_CARD',
  activateCard = 'ACTIVATE_CARD',
  permanentBlockCard = 'PERMANENT_BLOCK_CARD',
  resetPinAttempts = 'RESET_PIN_ATTEMPTS',
}
